var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function Svg1366(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 21,
    height: 27,
    viewBox: "0 0 21 27",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group 1267"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group 1261"
  }, /*#__PURE__*/React.createElement("g", {
    id: "g3997"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path3999",
    d: "M19.8607 6.48236V24.771C19.8607 25.5991 19.1865 26.2705 18.3549 26.2705H2.56823C1.73668 26.2705 1.0625 25.5991 1.0625 24.771V2.70577C1.0625 1.87761 1.73668 1.20629 2.56823 1.20629H14.5626C14.962 1.20629 15.345 1.36427 15.6274 1.64543L19.4196 5.42202C19.702 5.70324 19.8607 6.08466 19.8607 6.48236Z",
    stroke: "#404040",
    strokeWidth: 1.25321,
    strokeMiterlimit: 10
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group 1266"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M5.80452 17.4512L6.01096 17.3711C6.26515 17.6753 6.55652 17.9495 6.87815 18.188L6.80148 18.3614C6.42758 18.0985 6.09246 17.7922 5.80452 17.4512Z",
    fill: "#404040",
    stroke: "#404040",
    strokeWidth: 1.25321
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_2",
    d: "M14.3343 17.4442C14.047 17.7856 13.7125 18.0925 13.3391 18.356L13.262 18.1826C13.5831 17.9436 13.8739 17.669 14.1276 17.3644L14.3343 17.4442Z",
    fill: "#404040",
    stroke: "#404040",
    strokeWidth: 1.25321
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_3",
    d: "M10.4676 18.5842C10.4676 18.5842 10.4675 18.5842 10.4675 18.5842C10.4768 18.6486 10.4959 18.7094 10.5229 18.7654L10.5149 18.7474L10.5143 18.7459L10.5143 18.7459C10.4918 18.6949 10.4759 18.6405 10.4676 18.5842ZM10.0667 19.2272C10.2849 19.2272 10.5001 19.2144 10.7114 19.1895L10.7762 19.3352C10.5442 19.3635 10.3074 19.3781 10.0667 19.3781C9.82915 19.3781 9.59545 19.3639 9.36639 19.3364L9.43088 19.1906C9.63939 19.2148 9.85159 19.2272 10.0667 19.2272Z",
    fill: "#404040",
    stroke: "#404040",
    strokeWidth: 1.25321
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_4",
    d: "M5.45473 11.6511V10.8587C5.74751 10.9958 6.09913 10.9453 6.3438 10.7299C7.31049 9.879 8.61907 9.35219 10.0672 9.35219C13.0953 9.35219 15.4761 11.6359 15.4761 14.3652C15.4761 14.5822 15.4612 14.7958 15.4323 15.0053L15.1943 14.9134C15.2158 14.7333 15.2268 14.5504 15.2268 14.3652C15.2268 11.6405 12.8758 9.5031 10.0672 9.5031C8.74015 9.5031 7.52422 9.97628 6.60581 10.7599C6.33121 10.9942 6.26401 11.3513 6.37368 11.6511H5.45473ZM15.9248 15.1955L15.9242 15.1953L15.9248 15.1955ZM14.8662 14.7867C14.8664 14.7868 14.8665 14.7869 14.8667 14.7869L14.8662 14.7867L14.7111 15.1884L14.8662 14.7867Z",
    fill: "#404040",
    stroke: "#404040",
    strokeWidth: 1.25321
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(Svg1366);
export default __webpack_public_path__ + "static/media/1366.eb682a0fcb70909cc8f028aa9b9974eb.svg";
export { ForwardRef as ReactComponent };